import { render, staticRenderFns } from "./ServiceRequestPropertiesView.vue?vue&type=template&id=1dc6dc32&scoped=true&"
import script from "./ServiceRequestPropertiesView.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestPropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc6dc32",
  null
  
)

export default component.exports